<template>
  <span class="badge" v-if="count !== null && ( count > 0 || showZero )">{{ display }}</span>
</template>

<script>
import numeral from 'numeral'
import axios from 'axios'

export default {
  name: 'badge',
  props: {
    default: {
      type: Number,
      default: null
    },
    showZero: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: '0,0a'
    },
    ajax: {
      type: String,
      default: null
    },
    delay: {
      type: Number,
      default: 10000
    }
  },
  data () {
    return {
      count: null,
      display: null
    }
  },
  mounted () {
    this.count = this.default

    if (this.ajax) {
      // create the interval
      setInterval(() => {
        this.update()
      }, this.delay)
      // get the first update
      if (this.default === null) {
        this.update()
      }
    }
  },
  watch: {
    count () {
      this.display = this.count !== null ? numeral(this.count).format(this.format) : ''
    }
  },
  methods: {
    update () {
      axios.get(this.ajax).then((response) => {
        this.count = response.data
      })
    }
  }
}
</script>